import '../../DefaultButton.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import { DefaultButton as DefaultButton$2 } from "@fluentui/react/lib/Button";
import { WithCallout } from "../Callout/WithCallout.js";
import { css } from "@fluentui/utilities";
const DefaultButton$1 = "";
const defaultClassName = "ane-DefaultButton";
const DefaultButton = (props) => {
  const { className } = props;
  return /* @__PURE__ */ jsx(WithCallout, { preventAutoTabIndex: true, calloutProps: props.calloutProps, children: /* @__PURE__ */ jsx(DefaultButton$2, __spreadProps(__spreadValues({}, props), { className: css(defaultClassName, className) })) });
};
export {
  DefaultButton,
  DefaultButton as default
};
//# sourceMappingURL=DefaultButton.js.map
